import React from 'react';

export function HeaderWaves({ isScrolled, waveBubbles }) {
  return (
          <div className="wave-wrap" style={isScrolled ? { height: 0, opacity: 0, overflow: 'hidden' } : {}}>
        <svg viewBox="0 0 1440 36" className="block wave-svg" style={{ width: 'calc(100% + 40px)', height: '100%', marginLeft: '-20px' }} preserveAspectRatio="none">
          <defs>
            {/* Hauptwelle - Türkis/Cyan */}
            <linearGradient id="waveMain" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.85" />
              <stop offset="50%" stopColor="#06b6d4" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#0891b2" stopOpacity="0.2" />
            </linearGradient>
            
            {/* Zweite Welle - Hellblau */}
            <linearGradient id="waveSecond" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.7" />
              <stop offset="60%" stopColor="#0ea5e9" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#0284c7" stopOpacity="0.1" />
            </linearGradient>
            
            {/* Dritte Welle - Akzent */}
            <linearGradient id="waveAccent" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#67e8f9" stopOpacity="0.6" />
              <stop offset="40%" stopColor="#22d3ee" stopOpacity="0.3" />
              <stop offset="100%" stopColor="transparent" stopOpacity="0" />
            </linearGradient>
            
            {/* Highlight/Glow */}
            <linearGradient id="waveGlow" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#a5f3fc" stopOpacity="0.5" />
              <stop offset="30%" stopColor="#67e8f9" stopOpacity="0.25" />
              <stop offset="100%" stopColor="transparent" stopOpacity="0" />
            </linearGradient>
            
            {/* Neue Blautöne oben */}
            <linearGradient id="waveBlue1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.55" />
              <stop offset="50%" stopColor="#2563eb" stopOpacity="0.3" />
              <stop offset="100%" stopColor="transparent" stopOpacity="0" />
            </linearGradient>
            
            <linearGradient id="waveBlue2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#60a5fa" stopOpacity="0.45" />
              <stop offset="40%" stopColor="#3b82f6" stopOpacity="0.2" />
              <stop offset="100%" stopColor="transparent" stopOpacity="0" />
            </linearGradient>
            
            {/* Dunkelblau Welle - tiefes Marineblau */}
            <linearGradient id="waveDarkBlue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0a1929" stopOpacity="0.8" />
              <stop offset="40%" stopColor="#071422" stopOpacity="0.3" />
              <stop offset="100%" stopColor="#050d18" stopOpacity="0" />
            </linearGradient>
            
            {/* Mittelblau Welle */}
            <linearGradient id="waveMidBlue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#1a365d" stopOpacity="0.8" />
              <stop offset="40%" stopColor="#1e3a5f" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#143052" stopOpacity="0" />
            </linearGradient>
            
            {/* Kobaltblau Welle */}
            <linearGradient id="waveCobalt" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#2563eb" stopOpacity="0.8" />
              <stop offset="50%" stopColor="#1d4ed8" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#1e40af" stopOpacity="0" />
            </linearGradient>
            
            {/* Neon Cyan Glow - hell leuchtend */}
            <linearGradient id="waveNeonCyan" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00ffff" stopOpacity="0.9" />
              <stop offset="30%" stopColor="#00d4ff" stopOpacity="0.65" />
              <stop offset="100%" stopColor="#00a0d2" stopOpacity="0.3" />
            </linearGradient>
            
            {/* Neon Blau Glow - elektrisches Blau */}
            <linearGradient id="waveNeonBlue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#60a5fa" stopOpacity="0.85" />
              <stop offset="40%" stopColor="#3b82f6" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#2563eb" stopOpacity="0.25" />
            </linearGradient>
            
            {/* Neon Hellblau - sehr hell */}
            <linearGradient id="waveNeonLight" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#a5f3fc" stopOpacity="0.8" />
              <stop offset="40%" stopColor="#67e8f9" stopOpacity="0.55" />
              <stop offset="100%" stopColor="#22d3ee" stopOpacity="0.2" />
            </linearGradient>
            
            {/* Neon Glow Filter */}
            <filter id="neonGlow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="2" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            
            {/* Sanfter Neon Glow Filter - für subtilen Schimmer */}
            <filter id="neonGlowSoft" x="-30%" y="-30%" width="160%" height="160%">
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          
          {/* 1. Tiefstes Dunkelblau - ganz hinten */}
          <path 
            className="wave-layer wave-darkblue" 
            d="M0,34 Q240,28 480,32 T960,29 T1440,34 L1440,36 L0,36 Z" 
            fill="url(#waveDarkBlue)" 
          />
          
          {/* 2. Dunkles Marineblau */}
          <path 
            className="wave-layer wave-midblue" 
            d="M0,30 Q180,23 360,27 T720,24 T1080,28 T1440,30 L1440,36 L0,36 Z" 
            fill="url(#waveMidBlue)" 
          />
          {/* Linie auf Marineblau */}
          <path 
            className="wave-line wave-line-1" 
            d="M0,30 Q180,23 360,27 T720,24 T1080,28 T1440,30" 
            fill="none"
            stroke="rgba(10, 25, 41, 0.95)"
            strokeWidth="1.5"
          />
          
          {/* 3. Mittleres Dunkelblau */}
          <path 
            className="wave-layer wave-cobalt" 
            d="M0,25 Q200,17 400,22 T800,18 T1200,23 T1440,25 L1440,36 L0,36 Z" 
            fill="url(#waveCobalt)" 
          />
          {/* Linie auf Kobaltblau */}
          <path 
            className="wave-line wave-line-2" 
            d="M0,25 Q200,17 400,22 T800,18 T1200,23 T1440,25" 
            fill="none"
            stroke="rgba(26, 54, 93, 0.9)"
            strokeWidth="1.5"
          />
          
          {/* 4. Kobaltblau - kräftiger */}
          <path 
            className="wave-layer wave-neon-blue" 
            d="M0,19 Q150,12 300,16 T600,13 T900,17 T1200,14 T1440,19 L1440,36 L0,36 Z" 
            fill="url(#waveNeonBlue)" 
          />
          {/* Linie auf Blau */}
          <path 
            className="wave-line wave-line-3" 
            d="M0,19 Q150,12 300,16 T600,13 T900,17 T1200,14 T1440,19" 
            fill="none"
            stroke="rgba(37, 99, 235, 0.85)"
            strokeWidth="1.2"
            filter="url(#neonGlowSoft)"
          />
          
          {/* 5. Neon Hellblau - erste Neon-Welle */}
          <path 
            className="wave-layer wave-neon-light" 
            d="M0,12 Q180,5 360,10 T720,6 T1080,11 T1440,12 L1440,36 L0,36 Z" 
            fill="url(#waveNeonLight)" 
            filter="url(#neonGlow)"
          />
          {/* Neon Linie */}
          <path 
            className="wave-line wave-line-4" 
            d="M0,12 Q180,5 360,10 T720,6 T1080,11 T1440,12" 
            fill="none"
            stroke="rgba(165, 243, 252, 0.95)"
            strokeWidth="1"
            filter="url(#neonGlow)"
          />
          
          {/* 6. Neon Cyan - ganz oben, hellste Welle */}
          <path 
            className="wave-layer wave-neon-cyan" 
            d="M0,6 Q200,1 400,5 T800,2 T1200,5 T1440,6 L1440,36 L0,36 Z" 
            fill="url(#waveNeonCyan)" 
            filter="url(#neonGlowSoft)"
          />
          {/* Oberste Neon-Linie */}
          <path 
            className="wave-line wave-line-top" 
            d="M0,6 Q200,1 400,5 T800,2 T1200,5 T1440,6" 
            fill="none"
            stroke="rgba(0, 255, 255, 0.95)"
            strokeWidth="1.5"
            filter="url(#neonGlow)"
          />        </svg>
        
        {/* Wave-Bubbles - steigen von den Wellen auf und platzen nach oben */}
        <div className="wave-bubbles-layer">
          {waveBubbles.map(b => (
            <span 
              key={b.id}
              className={`wave-bubble-pop ${b.sizeClass}`}
              style={{
                '--x': `${b.left}%`,
                '--drift': `${b.drift}px`,
                '--duration': `${b.duration}s`
              }}
            />
          ))}
        </div>
      </div>
  );
}